import React from 'react';
import Checkbox from './Checkbox';

interface CheckboxesOption {
  id: string;
  label: string;
  value?: string;
  disabled?: boolean;
}

interface CheckboxesProps {
  options?: CheckboxesOption[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  legend?: string;
  hint?: string;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
}

const DEFAULT_OPTIONS: CheckboxesOption[] = [{ id: 'option1', label: 'Option 1' }];

const Checkboxes: React.FC<CheckboxesProps> = ({
  options = DEFAULT_OPTIONS,
  selectedValues,
  onChange,
  legend,
  hint,
  hintClassName,
  hintId,
  hintHidden,
}) => {
  const handleToggle = (value: string) => {
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter((v) => v !== value));
      return;
    }
    onChange([...selectedValues, value]);
  };

  return (
    <>
      {legend ? <legend>{legend}</legend> : null}
      {options.map((option) => {
        const value = option.value ?? option.id;
        return (
          <Checkbox
            key={option.id}
            id={option.id}
            htmlFor={option.id}
            label={option.label}
            value={value}
            checked={selectedValues.includes(value)}
            onChange={() => handleToggle(value)}
            disabled={option.disabled}
          />
        );
      })}
      {hint ? (
        <small
          id={hintId}
          hidden={hintHidden}
          className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
        >
          {hint}
        </small>
      ) : null}
    </>
  );
};

export default Checkboxes;
